module.exports = __webpack_public_path__ + "static/media/aa7.38f30183.jpg";